import React from 'react'
import {connect} from "react-redux"
import PropTypes from 'prop-types'

import { 
  selectActiveModal,
  selectContextById,
  selectNestedFilterTree,
} from '../../State/selectors.js'

import { 
  toggleFilter,
  toggleNesting
} from '../../State/actions.js'

const mapStateToProps = (state) => {
  var contextId = selectActiveModal(state)
  if (contextId) {
    var context = selectContextById(state, contextId)
    var filterTree = selectNestedFilterTree(state, contextId)
  } 
  else {
    return {}
  }

  return { 
    contextId,
    context,
    filterTree
  }
}

const actions = {
  toggleFilter,
  toggleNesting
}

class NestedList extends React.Component {
  static get propTypes () {
    return {
      contextId: PropTypes.string,
      context: PropTypes.object,
      toggleFilter: PropTypes.func,
      filterTree: PropTypes.array,
      toggleNesting: PropTypes.func
    }
  }

  renderChildItems (parent) {
    var { toggleFilter } = this.props
    var children = []

    var checked = parent.selectionState === "checked"

    children.push(
      <li className="fdn-search-modal-item" key={`all-${parent.id}`}>

        <div>
          <input type="checkbox" 
            checked={!!checked}
            id={`checkboxall-${parent.value}`} 
            onChange={ () => toggleFilter(parent.id) }
            className="uk-checkbox uk-margin-small-right"/>

          <label htmlFor={`checkboxall-${parent.value}`}>
            { `All ${parent.name}` }
          </label>
        </div>
      </li>
    )

    children = children.concat(parent.children.map(childItem => {
      var checked = childItem.selectionState === "checked"

      return  (
        <li className="fdn-search-modal-item" key={childItem.id}>
          <div>
            <input type="checkbox" 
              checked={!!checked}
              onChange={ () => toggleFilter(childItem.id) }
              id={`checkbox-${childItem.value}`} 
              className="uk-checkbox uk-margin-small-right"/>

            <label htmlFor={`checkbox-${childItem.value}`}>
              { childItem.name }
            </label>
          </div>
        </li>
      )
    }))

    return children
  }

  render () {
    var { filterTree, toggleNesting } = this.props

    return (
      <ul className="uk-accordion uk-margin-remove">
        { filterTree.map( item => {
          var checked = item.selectionState === "checked"
          return (
            <li key={item.id}
              className={["uk-margin-remove", item.isOpen ? "uk-open" : ""].join(" ")}>

              <div className="uk-accordion-title checkbox-item-wrap fdn-search-modal-parent"
                onClick={() => toggleNesting(item.id)}>

                <input type="checkbox" 
                  id={`checkbox-${item.value}`} 
                  readOnly="true"
                  checked={!!checked}
                  className="uk-checkbox uk-margin-small-right"/>

                <label htmlFor={`checkbox-${item.value}`}
                  onClick={() => toggleNesting(item.id)}>

                  { item.name }
                </label>
              </div>

              <div className="uk-accordion-content uk-margin-remove fdn-search-modal-accordion" 
                hidden={!item.isOpen}>

                <ul className="uk-list uk-column-1-2@s uk-column-1-3@m">
                  { this.renderChildItems(item) } 
                </ul>
              </div>
            </li>
          )
        })}
      </ul>
    )
  }
}

export default connect(mapStateToProps, actions)(NestedList);
